module.exports = __webpack_public_path__ + "img/IAFA.e1296e05.jpg";